var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('circle',{class:[_vm.$style.liverpool, _vm.isSelected ? _vm.$style.selected : ''],attrs:{"r":"1"}})}
var staticRenderFns = []

export { render, staticRenderFns }